import { ROUTES as e } from "@editor/ui-utils";
//#endregion
//#region src/index.ts
var t = {
	messages: {
		en: { catTool: { openButton: "Open CAT" } },
		de: { catTool: { openButton: "CAT öffnen" } }
	},
	routes: [{
		path: `/${e.catTool.path}`,
		meta: { i18RouteTitleKey: e.catTool.path },
		children: [{
			path: "",
			name: "cat_tool_entrypoint",
			component: () => import("./cat-tool-entrypoint.view-CaQfxDxJ.js"),
			meta: { requiredRight: "cat-tool:navigate" }
		}]
	}],
	contentBlocks: []
};
//#endregion
export { t as catToolModule };

//# sourceMappingURL=index.es.js.map